import React from "react";
import { Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  Directions,
  genderEnumReversed,
  globalConstants,
  translationConstants,
} from "../../../constants";
import { competitionActions } from "../../../redux/actions";
import { getUserPayload } from "../../../system";

const BoatClassPaymentModal = ({ setShow, onSuccess, selectedCompetition }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const userPayload = getUserPayload();

  const userBoatClass = useSelector(
    (state) => state.CompetitionReducer?.userBoatClass
  );
  const direction = useSelector(
    (state) => state.LanguageChangeReducer.direction
  );

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    dispatch(
      competitionActions.addParticipant(
        {
          systemUserId: userPayload?.user?.id,
          competitionId: selectedCompetition,
          genderBoatClassId: data?.boatClassId,
        },
        setShow,
        onSuccess
      )
    );
  };

  return (
    <div className="pt-2 mx-2">
      <span className="loginPara">
        {t(translationConstants.REGISTER_FOR_COMPETITION)}
      </span>
      <hr className="horizontal-line" />

      <Form noValidate onSubmit={handleSubmit(onSubmit)}>
        <Form.Group className="mx-0 mt-2 mb-4">
          <Form.Label className="font-13 font-weight-700">
            {`${t(translationConstants.CHOOSE_BOAT_CLASS_FOR_COMPETITION)}:` +
              globalConstants.Mandatory_Character}
          </Form.Label>
          <Form.Select
            id="boatClassId"
            {...register("boatClassId", {
              required: t(translationConstants.COMPETITION_BOAT_CLASS_REQUIRED),
            })}
          >
            <option value="">
              {t(translationConstants.SELECT_BOAT_CLASSS)}
            </option>
            {userBoatClass?.map((object) => {
              const name =
                direction === Directions.rtl && object.arabicName
                  ? object.arabicName
                  : object.name;
              const genderText = t(
                translationConstants[genderEnumReversed[object.gender]]
              );
              return (
                <option key={object.id} value={object.id}>
                  {`${name} - ${genderText}`}
                </option>
              );
            })}
          </Form.Select>
          {errors?.boatClassId && (
            <p className="errorText">{errors?.boatClassId?.message}</p>
          )}
        </Form.Group>

        <Form.Group
          className="d-flex justify-content-space-between pt-4 pb-2"
          controlId="formBasicCheckbox"
        >
          <Form.Check
            className="custom-checkbox custom-checkboxInput"
            type="checkbox"
            {...register("paymentRegulations", {
              required: t(translationConstants.PAYMNET_REGULATION_REQUIRED),
            })}
          />
          <div className="font-12">
            {t(translationConstants.AGREE_TO_TERMS)}{" "}
            <a className="center-card-view-detail-link approved-color cursor-not-allowed">
              {t(translationConstants.PAYMENT_REGULATIONS)}
            </a>
          </div>
        </Form.Group>
        {errors?.paymentRegulations && (
          <p className="errorText pb-2">
            {errors?.paymentRegulations?.message}
          </p>
        )}

        <div className="py-2">
          <Button className="Login-button w-50" type="submit">
            {t(translationConstants.REGISTER_NOW)}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default BoatClassPaymentModal;
